import script from "./quick-images.vue?vue&type=script&setup=true&lang=js"
export * from "./quick-images.vue?vue&type=script&setup=true&lang=js"

import "./quick-images.vue?vue&type=style&index=0&id=1b770fd8&lang=scss&scoped=true"

import exportComponent from "/Users/shuaqq/Desktop/jysports/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b770fd8"]])

export default __exports__